import { createFileRoute } from '@tanstack/react-router'
import { DefaultsSection } from '../../../features/settings/defaults-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/defaults')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'defaults'),
  component: DefaultsSection,
})
